import { render, staticRenderFns } from "./EmailCheck.vue?vue&type=template&id=5c68b585"
import script from "./EmailCheck.vue?vue&type=script&lang=js"
export * from "./EmailCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports